import { render, staticRenderFns } from "./superCollect.vue?vue&type=template&id=b3b17fec&"
import script from "./superCollect.vue?vue&type=script&lang=js&"
export * from "./superCollect.vue?vue&type=script&lang=js&"
import style0 from "./superCollect.vue?vue&type=style&index=0&id=b3b17fec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports